import styled from "styled-components";

export const HiddenScroll = styled.div`
  max-height: ${({ maxHeight }) => maxHeight}px;
  overflow-y: auto;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.light2};
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;

  /* Ocultar scrollbars en WebKit */
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Firefox */
  scrollbar-width: none;

  /* IE/Edge (antiguo) */
  -ms-overflow-style: none;
`;